// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://lnufhgqbsuccywthzrrb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxudWZoZ3Fic3VjY3l3dGh6cnJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3NDgwNTYsImV4cCI6MjA2OTMyNDA1Nn0.NDpyatqXSSvThxRtkvMi77AQrdQRHHdC88BjXefeQIg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});